import { SpecialOfferLandingSettings, SpecialOfferList } from "./types";

export const getLandingSettingsFromSpecialList = (
  specialOfferList: SpecialOfferList
): SpecialOfferLandingSettings[] =>
  specialOfferList.map((specialOffer) => ({
    id: specialOffer.id,
    ...specialOffer.landingSettings,
  }));

export const getSpecialOfferAnalyticsId = (
  data: SpecialOfferLandingSettings
) => {
  const id = data?.id;
  const title = data?.title;

  return id && title ? `${id}_${title}` : "";
};

export const capitalizeFirstLetter = (value?: string): string => {
  if (!value) {
    return "";
  }

  return value[0].toUpperCase() + value.slice(1).toLowerCase();
};
